"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var index_module_scss_1 = __importDefault(require("./index.module.scss"));
var react_i18next_1 = require("react-i18next");
function FaqLayout(_a) {
    var _b;
    var faqs = _a.faqs;
    var _c = (0, react_1.useState)(0), activeIndex = _c[0], setActiveIndex = _c[1];
    var _d = (0, react_1.useState)(false), loading = _d[0], setLoading = _d[1];
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.faqBody }, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: index_module_scss_1.default.heading }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "faqs" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.faqs }, { children: (_b = faqs === null || faqs === void 0 ? void 0 : faqs.Questions) === null || _b === void 0 ? void 0 : _b.map(function (r, i) {
                        return ((0, jsx_runtime_1.jsx)("div", __assign({ onClick: function () {
                                return r.answer && setActiveIndex(activeIndex === i ? "" : i);
                            }, className: r.answer
                                ? index_module_scss_1.default.Accordion
                                : "".concat(index_module_scss_1.default.Accordion, " ").concat(index_module_scss_1.default.AccordionHeader) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: r.answer && activeIndex === i ? index_module_scss_1.default.active : "" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.content }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", { children: r === null || r === void 0 ? void 0 : r.question }), activeIndex === i && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("p", { dangerouslySetInnerHTML: { __html: r === null || r === void 0 ? void 0 : r.answer } }) }))] }), r.answer && ((0, jsx_runtime_1.jsx)("img", { className: index_module_scss_1.default.icon, src: activeIndex === i ? "/close.svg" : "/expand.svg" }))] })) })) })));
                    }) }))] })) }));
}
exports.default = FaqLayout;
